<mat-card-content class="dialog-container">
  <div class="timeout-header">
    <mat-icon class="warning-icon">info</mat-icon>
    <h2>Avertissement d'inactivité</h2>
  </div>
  
  <mat-dialog-content class="dialog-content">
    <p class="subtitle">Votre session va expirer en raison de l'inactivité.</p>
    
    <div class="speedometer-container">
      <svg class="speedometer" viewBox="0 0 100 100">
        <!-- Background track -->
        <path class="track" d="M 21.72 78.28 A 40 40 0 1 1 78.28 78.28" />
        <!-- Progress bar -->
        <path class="progress" [class.danger]="counter <= 10" d="M 21.72 78.28 A 40 40 0 1 1 78.28 78.28" 
              [style.stroke-dashoffset]="188.5 - (counter / 60) * 188.5" />
      </svg>
      <div class="counter-text">
        <span class="value" [class.danger]="counter <= 10">{{counter}}</span>
        <span class="unit">secondes</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="actions">
    <button mat-raised-button color="primary" (click)="continue()" class="btn-action">
      <mat-icon>play_arrow</mat-icon> Continuer la session
    </button>
    <button mat-stroked-button color="warn" (click)="close()" class="btn-action">
      <mat-icon>exit_to_app</mat-icon> Se déconnecter
    </button>
  </mat-dialog-actions>
</mat-card-content>
